import {
  useEntitiesFulfillmentPlanProperty,
  useFulfillmentRestrictionsByFPId,
} from '../../../../../../hooks/entities/selectors/fulfillment-plans';
import { useActiveFulfillmentForFulfillmentPlan } from '../../../../../../hooks/entities/selectors/fulfillments';
import { useIsManualOrder } from '../../../../../../hooks/use-is-manual-order';
import { ComponentStates } from '../../../../../../enums/component-states';
import { useEnableReship } from '../../../../../../feature-flags/hooks/use-enable-reship';
import { useEnableAddShipmentItems } from '../../../../../../feature-flags/hooks/use-enable-add-shipment-items';

export const useCanEditShipmentItems = (fulfillmentPlanId, salesOrderId) => {
  const isReshipEnabled = useEnableReship();
  const isManualOrder = useIsManualOrder(salesOrderId);
  const isAddShipmentItemsEnabled = useEnableAddShipmentItems();

  const fulfillmentPlanItems = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'items') || [];
  const fulfillmentPlanHasAdditionalItems = fulfillmentPlanItems.some((item) => !item.salesOrderItemId);
  const isReship = isReshipEnabled && fulfillmentPlanHasAdditionalItems;

  const activeFulfillment = useActiveFulfillmentForFulfillmentPlan(fulfillmentPlanId);
  const hasActiveFulfillment = !!activeFulfillment;

  const uiRestrictions = useFulfillmentRestrictionsByFPId(fulfillmentPlanId);
  const hasUIRestrictions = uiRestrictions?.items?.componentState === ComponentStates.ReadOnly;
  const canEditShipmentItems = (isManualOrder || isReship || isAddShipmentItemsEnabled) && !(hasActiveFulfillment || hasUIRestrictions);
  return {
    canEditShipmentItems,
    fulfillmentPlanHasAdditionalItems,
  };
};
